if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.mainAtcButton = this.productSection.querySelector('.js-product-form-main button[name="add"]');
      this.bindEvents();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    bindEvents() {
      // Delegacja (nie listener na przycisku) — dynamic-variant-content może
      // podmienić innerHTML panelu przy zmianie wariantu.
      this.addEventListener('click', (e) => {
        if (!e.target.closest('.js-fl-sticky-add')) return;
        if (this.mainAtcButton && !this.mainAtcButton.disabled) this.mainAtcButton.click();
      });

      // Pasek widoczny zawsze, gdy głównego przycisku Dodaj do koszyka nie widać
      // na ekranie (za mały viewport albo przescrollowane) — desktop i mobile.
      if (this.mainAtcButton && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
            this.classList.remove('invisible');
          });
        });
        this.observer.observe(this.mainAtcButton);
      } else {
        this.classList.remove('sticky-atc-panel--out', 'invisible');
      }
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
